import { render, staticRenderFns } from "./PdfElementSettings.vue?vue&type=template&id=cf5ac142&scoped=true&"
import script from "./PdfElementSettings.vue?vue&type=script&lang=ts&"
export * from "./PdfElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5ac142",
  null
  
)

export default component.exports